const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogAnoLetivo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAnoLetivo`, params);
    },
    $obterRelatorioLogCSVAnoLetivo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAnoLetivoCsv`, params);
    },
    $obterRelatorioLogPDFAnoLetivo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogAnoLetivoPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
